import { Component, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { PlayerAgeFilterModal, PlayerContractFilterModal, PlayerCountryFilterModal, PlayerPositionFilterModal, PlayerSkillFilterModal } from "app/components";
import { CountryDto, PlayerFilter } from "app/models";
import { CONSTANTS } from '../../constants';
import { CountryService } from "app/services/country.service";
import { NotificationService } from "app/services";

@Component({
    selector: 'players-page',
    templateUrl: './players.page.html',
    styleUrls: ['./players.page.scss'],
})
export class PlayersPage implements OnInit {

    filters: PlayerFilter[] = [];
    positionFilters: PlayerFilter[] = [];
    sideFilters: PlayerFilter[] = [];
    ageFilters: PlayerFilter[] = [];
    skillFilters: PlayerFilter[] = [];
    contractFilters: PlayerFilter[] = [];
    countryFilters: PlayerFilter[] = [];

    countries: CountryDto[];

    isInit: boolean = false;
    
    constructor(private modalService: NgbModal, private countryService: CountryService, private notificationService: NotificationService)  {}

    ngOnInit(): void {
        this.loadCountries();
    }

    
    openPositionFilter() {
        let filters = {
            gk: false,
            sw: false,
            df: false,
            dm: false,
            mf: false,
            am: false,
            fw: false,
            l: false,
            c: false,
            r: false
        }

        this.positionFilters.forEach(item => {
            if (item.filterValue === CONSTANTS.tacticPositions.gk) {
                filters.gk = true;
            }

            if (item.filterValue === CONSTANTS.tacticPositions.gk) {
                filters.gk = true;
            }

            if (item.filterValue === CONSTANTS.tacticPositions.df) {
                filters.df = true;
            }

            if (item.filterValue === CONSTANTS.tacticPositions.dm) {
                filters.dm = true;
            }

            if (item.filterValue === CONSTANTS.tacticPositions.mf) {
                filters.mf = true;
            }

            if (item.filterValue === CONSTANTS.tacticPositions.am) {
                filters.am = true;
            }

            if (item.filterValue === CONSTANTS.tacticPositions.fw) {
                filters.fw = true;
            }
        });

        this.sideFilters.forEach(item => {
            if (item.filterValue === CONSTANTS.playerSides.L) {
                filters.l = true;
            }

            if (item.filterValue === CONSTANTS.playerSides.C) {
                filters.c = true;
            }

            if (item.filterValue === CONSTANTS.playerSides.R) {
                filters.r = true;
            }
        });

        const modalRef = this.modalService.open(PlayerPositionFilterModal);
        
                modalRef.componentInstance.filters = filters;
        
                modalRef.result.then((result: any) => {
                    if (result) {
                        this.rebuildPositionFilter(result);
                        this.rebuildSideFilter(result);
                    }
                }, (reason) => { });
    }

    openAgeFilter() {
        const modalRef = this.modalService.open(PlayerAgeFilterModal);
        
               // modalRef.componentInstance.filters = filters;
        
                modalRef.result.then((result: any) => {
                    if (result) {
                        this.rebuildAgeFilter(result);
                    }
                }, (reason) => { });
    }

    openSkillFilter() {
        const modalRef = this.modalService.open(PlayerSkillFilterModal, { size: 'lg' });
        
               // modalRef.componentInstance.filters = filters;
        
                modalRef.result.then((result: any) => {
                    if (result) {
                        this.rebuildSkillFilter(result);
                    }
                }, (reason) => { });
    }

    openContractFilter() {
        const modalRef = this.modalService.open(PlayerContractFilterModal, { size: 'lg' });
        
               // modalRef.componentInstance.filters = filters;
        
                modalRef.result.then((result: any) => {
                    if (result) {
                        this.rebuildContractFilter(result);
                    }
                }, (reason) => { });
    }

    openCountryFilter() {
        const modalRef = this.modalService.open(PlayerCountryFilterModal, { size: 'lg' });
        
               modalRef.componentInstance.countries = this.countries;
        
                modalRef.result.then((result: CountryDto[]) => {
                    if (result) {
                        this.rebuildCountryFilter(result);
                    }
                }, (reason) => { });
    }

    removeFilter(filter: PlayerFilter) {
        switch(filter.filterType) {
            case CONSTANTS.playerFilterTypes.position:
                this.removePositionFilter(filter);
                break;
            case CONSTANTS.playerFilterTypes.side:
                this.removeSideFilter(filter);
                break;
            case CONSTANTS.playerFilterTypes.age:
                this.removeAgeFilter(filter);
                break;
            case CONSTANTS.playerFilterTypes.skill:
                this.removeSkillFilter(filter);
                break;
            case CONSTANTS.playerFilterTypes.contract:
                this.removeContractFilter(filter);
                break;
            case CONSTANTS.playerFilterTypes.country:
                this.removeCountryFilter(filter);
                break;
        }
    }

    private rebuildFilters() {
        this.filters = [];

        this.filters = [...this.positionFilters, ...this.sideFilters, ...this.ageFilters,
             ...this.skillFilters, ...this.contractFilters, ...this.countryFilters];
    }

    private rebuildPositionFilter(filter: any) {
        this.positionFilters = [];

        if (filter.gk) {
            this.positionFilters.push(this.createPlayerPositionFilter(CONSTANTS.tacticPositions.gk, CONSTANTS.tacticPositionNames.gk));
        }

        if (filter.sw) {
            this.positionFilters.push(this.createPlayerPositionFilter(CONSTANTS.tacticPositions.sw, CONSTANTS.tacticPositionNames.sw));
        }

        if (filter.df) {
            this.positionFilters.push(this.createPlayerPositionFilter(CONSTANTS.tacticPositions.df, CONSTANTS.tacticPositionNames.df));
        }

        if (filter.dm) {
            this.positionFilters.push(this.createPlayerPositionFilter(CONSTANTS.tacticPositions.dm, CONSTANTS.tacticPositionNames.dm));
        }

        if (filter.mf) {
            this.positionFilters.push(this.createPlayerPositionFilter(CONSTANTS.tacticPositions.mf, CONSTANTS.tacticPositionNames.mf));
        }

         if (filter.am) {
            this.positionFilters.push(this.createPlayerPositionFilter(CONSTANTS.tacticPositions.am, CONSTANTS.tacticPositionNames.am));
        }

         if (filter.fw) {
            this.positionFilters.push(this.createPlayerPositionFilter(CONSTANTS.tacticPositions.fw, CONSTANTS.tacticPositionNames.fw));
        }

        this.rebuildFilters();
    }

    private rebuildSideFilter(filter: any) {
        this.sideFilters = [];

        if (filter.l) {
            this.sideFilters.push(this.createPlayerSideFilter(CONSTANTS.playerSides.L, "L"));
        }

        if (filter.c) {
            this.sideFilters.push(this.createPlayerSideFilter(CONSTANTS.playerSides.C, "C"));
        }

        if (filter.r) {
            this.sideFilters.push(this.createPlayerSideFilter(CONSTANTS.playerSides.R, "R"));
        }

        this.rebuildFilters();
    }

    private rebuildAgeFilter(filter: any) {
        this.ageFilters = [];

        if (!filter.minAge && !filter.maxAge) {
            this.rebuildFilters();
            return;
        }

        if (filter.minAge === filter.maxAge) {
            this.ageFilters.push(this.createPlayerAgeFilter(filter.minAge, filter.maxAge));
        } else {

            if (filter.minAge) {
                this.ageFilters.push(this.createPlayerAgeFilter(filter.minAge, undefined));
            }

            if (filter.maxAge) {
                this.ageFilters.push(this.createPlayerAgeFilter(undefined, filter.maxAge));
            }
        }

        this.rebuildFilters();
    }

    private rebuildSkillFilter(filter: any) {
        this.skillFilters = [];

        if (filter.minStamina || filter.maxStamina) {
            this.skillFilters.push(...this.createPlayerSkillFilter(filter.minStamina, filter.maxStamina, CONSTANTS.playerSkills.stamina, CONSTANTS.playerSkillsShortNames.stamina));
        }

        if (filter.minForce || filter.maxForce) {
            this.skillFilters.push(...this.createPlayerSkillFilter(filter.minForce, filter.maxForce, CONSTANTS.playerSkills.force, CONSTANTS.playerSkillsShortNames.force));
        }

        if (filter.minSpeed || filter.maxSpeed) {
            this.skillFilters.push(...this.createPlayerSkillFilter(filter.minSpeed, filter.maxSpeed, CONSTANTS.playerSkills.speed, CONSTANTS.playerSkillsShortNames.speed));
        }

        if (filter.minDrible || filter.maxDrible) {
            this.skillFilters.push(...this.createPlayerSkillFilter(filter.minDrible, filter.maxDrible, CONSTANTS.playerSkills.dribble, CONSTANTS.playerSkillsShortNames.dribble));
        }

        if (filter.minFreekick || filter.maxFreekick) {
            this.skillFilters.push(...this.createPlayerSkillFilter(filter.minFreekick, filter.maxFreekick, CONSTANTS.playerSkills.freekick, CONSTANTS.playerSkillsShortNames.freekick));
        }

        if (filter.minCorner || filter.maxCorner) {
            this.skillFilters.push(...this.createPlayerSkillFilter(filter.minCorner, filter.maxCorner, CONSTANTS.playerSkills.corner, CONSTANTS.playerSkillsShortNames.corner));
        }


        if (filter.minAccuracy || filter.maxAccuracy) {
            this.skillFilters.push(...this.createPlayerSkillFilter(filter.minAccuracy, filter.maxAccuracy, CONSTANTS.playerSkills.accuracy, CONSTANTS.playerSkillsShortNames.accuracy));
        }

        if (filter.minPowerShot || filter.maxPowerShot) {
            this.skillFilters.push(...this.createPlayerSkillFilter(filter.minPowerShot, filter.maxPowerShot, CONSTANTS.playerSkills.powerShot, CONSTANTS.playerSkillsShortNames.powerShot));
        }

        if (filter.minVision || filter.maxVision) {
            this.skillFilters.push(...this.createPlayerSkillFilter(filter.minVision, filter.maxVision, CONSTANTS.playerSkills.vision, CONSTANTS.playerSkillsShortNames.vision));
        }


        if (filter.minPosition || filter.maxPosition) {
            this.skillFilters.push(...this.createPlayerSkillFilter(filter.minPosition, filter.maxPosition, CONSTANTS.playerSkills.position, CONSTANTS.playerSkillsShortNames.position));
        }

        if (filter.minHeading || filter.maxHeading) {
            this.skillFilters.push(...this.createPlayerSkillFilter(filter.minHeading, filter.maxHeading, CONSTANTS.playerSkills.heading, CONSTANTS.playerSkillsShortNames.heading));
        }

        if (filter.minTackling || filter.maxTackling) {
            this.skillFilters.push(...this.createPlayerSkillFilter(filter.minTackling, filter.maxTackling, CONSTANTS.playerSkills.tackling, CONSTANTS.playerSkillsShortNames.tackling));
        }

        if (filter.minCross || filter.maxCross) {
            this.skillFilters.push(...this.createPlayerSkillFilter(filter.minCross, filter.maxCross, CONSTANTS.playerSkills.cross, CONSTANTS.playerSkillsShortNames.cross));
        }

        if (filter.minPass || filter.maxPass) {
            this.skillFilters.push(...this.createPlayerSkillFilter(filter.minPass, filter.maxPass, CONSTANTS.playerSkills.pass, CONSTANTS.playerSkillsShortNames.pass));
        }

        if (filter.minGkOut || filter.maxGkOut) {
            this.skillFilters.push(...this.createPlayerSkillFilter(filter.minGkOut, filter.maxGkOut, CONSTANTS.playerSkills.gkOput, CONSTANTS.playerSkillsShortNames.gkOput));
        }

        if (filter.minGkThrow || filter.maxGkThrow) {
            this.skillFilters.push(...this.createPlayerSkillFilter(filter.minGkThrow, filter.maxGkThrow, CONSTANTS.playerSkills.gkThrow, CONSTANTS.playerSkillsShortNames.gkThrow));
        }

        if (filter.minTechnick || filter.maxTechnick) {
            this.skillFilters.push(...this.createPlayerSkillFilter(filter.minTechnick, filter.maxTechnick, CONSTANTS.playerSkills.technick, CONSTANTS.playerSkillsShortNames.technick));
        }

        if (filter.minGkHandling || filter.maxGkHandling) {
            this.skillFilters.push(...this.createPlayerSkillFilter(filter.minGkHandling, filter.maxGkHandling, CONSTANTS.playerSkills.gkHandling, CONSTANTS.playerSkillsShortNames.gkHandling));
        }

        if (filter.minGkReaction || filter.maxGkReaction) {
            this.skillFilters.push(...this.createPlayerSkillFilter(filter.minGkReaction, filter.maxGkReaction, CONSTANTS.playerSkills.gkReaction, CONSTANTS.playerSkillsShortNames.gkReaction));
        }


        this.rebuildFilters();
    }

    private rebuildContractFilter(filter: any) {
        this.contractFilters = [];

        if (filter.freeAgent) {
            this.contractFilters.push(this.createContractFilter(1, "Свободный агент"));
        }

        if (filter.lastYear) {
            this.contractFilters.push(this.createContractFilter(1, "Уходит в свободные"));
        }

        if (filter.national) {
            this.contractFilters.push(this.createContractFilter(1, "Игрок сборной"));
        }

        if (filter.schoolBoy) {
            this.contractFilters.push(this.createContractFilter(1, "Выпускник"));
        }

        if (filter.transfer) {
            this.contractFilters.push(this.createContractFilter(1, "Трансфер"));
        }

        if (filter.rent) {
            this.contractFilters.push(this.createContractFilter(1, "Аренда"));
        }

        this.rebuildFilters();
    }

    private rebuildCountryFilter(filter: CountryDto[]) {
        this.countryFilters = [];

        filter.forEach(item => {
            this.countryFilters.push(this.createCountryFilter(item.code, item.name));
        });

        this.rebuildFilters();
    }

    private createPlayerPositionFilter(pos: number, label: string): PlayerFilter{
            let f = new PlayerFilter();
            f.filterCondition = CONSTANTS.substitutionConditions.equal;
            f.filterType = CONSTANTS.playerFilterTypes.position;
            f.filterValue = pos;
            f.label = label

            return f;
    }

    private createPlayerSideFilter(pos: number, label: string): PlayerFilter{
            let f = new PlayerFilter();
            f.filterCondition = CONSTANTS.substitutionConditions.equal;
            f.filterType = CONSTANTS.playerFilterTypes.side;
            f.filterValue = pos;
            f.label = label

            return f;
    }

    private createPlayerAgeFilter(min: number | undefined, max: number | undefined): PlayerFilter {

            let f = new PlayerFilter();
            f.filterCondition = min === max ? CONSTANTS.substitutionConditions.equal : min === undefined ? CONSTANTS.substitutionConditions.less : CONSTANTS.substitutionConditions.more;
            f.filterType = CONSTANTS.playerFilterTypes.age;
            f.filterValue = min === undefined ? max : min;
            f.label = "Возраст:";

            if (f.filterCondition === CONSTANTS.substitutionConditions.equal) {
                f.label += f.filterValue;
            }

            if (f.filterCondition === CONSTANTS.substitutionConditions.less) {
                f.label += " < " + f.filterValue;
            }

            if (f.filterCondition === CONSTANTS.substitutionConditions.more) {
                f.label += " > " + f.filterValue;
            }

            return f;
    }

    private createPlayerSkillFilter(min: number | undefined, max: number | undefined, skill: number, label: string): PlayerFilter[]{
            
            if (min === max) {
                let f = new PlayerFilter();
                f.filterCondition = CONSTANTS.substitutionConditions.equal;
                f.filterType = CONSTANTS.playerFilterTypes.skill;
                f.additional = skill;
                f.filterValue = min;
                f.label = label + " = " +  min;

                return [f];
            }

            let result: PlayerFilter[] = [];

            if (min != undefined) {
                let f = new PlayerFilter();
                f.filterCondition = CONSTANTS.substitutionConditions.more;
                f.filterType = CONSTANTS.playerFilterTypes.skill;
                f.additional = skill;
                f.filterValue = min;
                f.label =  label + " > " + min;

                result.push(f);
            }

            if (max != undefined) {
                let f1 = new PlayerFilter();
                f1.filterCondition = CONSTANTS.substitutionConditions.less;
                f1.filterType = CONSTANTS.playerFilterTypes.skill;
                f1.additional = skill;
                f1.filterValue = max;
                f1.label = label + " < " + max;

                result.push(f1);
            }
            return result;
    }

    private createContractFilter(type: number, label: string): PlayerFilter {
            let f = new PlayerFilter();
            f.filterCondition = CONSTANTS.substitutionConditions.equal;
            f.filterType = CONSTANTS.playerFilterTypes.contract;
            f.additional = type;
            f.filterValue = 1;
            f.label = label;


            return f;
    }

    private createCountryFilter(code: string, label: string): PlayerFilter {
            let f = new PlayerFilter();
            f.filterCondition = CONSTANTS.substitutionConditions.equal;
            f.filterType = CONSTANTS.playerFilterTypes.country;
            f.filterStrValue = code;
            f.label = label;

            return f;
    }

    private removePositionFilter(filter: PlayerFilter) {
        
        const index = this.positionFilters.indexOf(filter);

        if (index > -1) {
            this.positionFilters.splice(index, 1); 

            this.rebuildFilters();
        }
    }

    private removeSideFilter(filter: PlayerFilter) {
        
        const index = this.sideFilters.indexOf(filter);

        if (index > -1) {
            this.sideFilters.splice(index, 1); 

            this.rebuildFilters();
        }
    }

    private removeAgeFilter(filter: PlayerFilter) {
        
        const index = this.ageFilters.indexOf(filter);

        if (index > -1) {
            this.ageFilters.splice(index, 1); 

            this.rebuildFilters();
        }
    }

    private removeSkillFilter(filter: PlayerFilter) {
        
        const index = this.skillFilters.indexOf(filter);

        if (index > -1) {
            this.skillFilters.splice(index, 1); 

            this.rebuildFilters();
        }
    }

    private removeContractFilter(filter: PlayerFilter) {
        
        const index = this.contractFilters.indexOf(filter);

        if (index > -1) {
            this.contractFilters.splice(index, 1); 

            this.rebuildFilters();
        }
    }

    private removeCountryFilter(filter: PlayerFilter) {
        
        const index = this.countryFilters.indexOf(filter);

        if (index > -1) {
            this.countryFilters.splice(index, 1); 

            this.rebuildFilters();
        }
    }

    private loadCountries() {
        this.countryService.getActiveCountries()
            .subscribe(result => {
                this.countries = result;
                this.isInit = true;
            }, error=> {
                this.notificationService.showError('Не удалось загрузить национальности.');
            })
    }
}